import { useState } from 'react';
import styles from './AppLock.module.css';

export function LockScreen({
  onUnlock,
}: {
  onUnlock: (password: string) => Promise<boolean>;
}) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const success = await onUnlock(password);
      if (!success) {
        setError('Incorrect password. Please try again.');
        setPassword('');
      }
    } catch {
      setError('Unlock failed. Please try again.');
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.screen}>
      <form onSubmit={handleSubmit} className={`${styles.card} ${styles.cardCenter}`}>
        <h1 className={`${styles.title} ${styles.titleLg}`}>
          ALG Locked
        </h1>
        <p className={styles.subtitle}>
          Enter your password to unlock.
        </p>

        {error && <div className={styles.error}>{error}</div>}

        <div className={styles.fieldLg}>
          <label htmlFor="lock-password" className={styles.labelHidden}>Password</label>
          <input
            id="lock-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
            placeholder="Password"
            className={`${styles.input} ${styles.inputCenter}`}
          />
        </div>

        <button
          type="submit"
          disabled={loading || !password}
          className={styles.primaryButton}
        >
          {loading ? 'Unlocking…' : 'Unlock'}
        </button>
      </form>
    </div>
  );
}
